import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    isSnackbarOpenSelector,
    snackbarTypeSelector,
    snackbarAdditionalOptionsSelector
} from '../common/selectors/snackbar-selectors';

import GeneralSuccessSnackbar from './general-success-snackbar';
import GeneralErrorSnackbar from './general-error-snackbar';

import {
    closeSnackbar
} from '../common/actions/snackbar-action-creators';

const snackbarTypeMap = {
    generalError: GeneralErrorSnackbar,
    generalSuccess: GeneralSuccessSnackbar,
};

export class SnackbarContainer extends Component{
    render(){
        const { additionalOptions, open, snackbarType, closeSnackbar } = this.props;
        const Snackbar = snackbarTypeMap[snackbarType] || GeneralSuccessSnackbar;

        return <Snackbar dataAutomationId="snackbar" open={open} onClose={closeSnackbar} additionalOptions={additionalOptions}/>;
    }
};

/* istanbul ignore next */
function mapStateToProps( state ){
    return {
        additionalOptions: snackbarAdditionalOptionsSelector( state ),
        open: isSnackbarOpenSelector( state ),
        snackbarType: snackbarTypeSelector( state ),
    };
}

SnackbarContainer.propTypes = {
    additionalOptions: PropTypes.object,
    closeSnackbar: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    snackbarType: PropTypes.oneOf( [...Object.keys( snackbarTypeMap ), null] ),
};

export default connect(
    mapStateToProps,
    { closeSnackbar }
)( SnackbarContainer );
